module.exports = __webpack_public_path__ + "img/icon_temple_edit_white.0822b9b7.svg";